import { useEffect, useRef } from "react";
import { JService } from "../api-service/ApiService";

export const MAX_RETRIES = 50; // Stop polling after 50 attempts (approximately 4 minutes)

const Index = ({
    securemeLink,
    sessionId,
    style,
    onPassed = () => {},
    onFailed = () => {},
    onRetry = () => {}
}) => {

    const retryCountRef = useRef(0);
    const sessionIdRef = useRef(sessionId);
    sessionIdRef.current = sessionId;

    const getResult = async () => {
        try {
            retryCountRef.current += 1;
            if (retryCountRef.current > MAX_RETRIES) {
                onFailed?.("KYC verification timed out. Please try again.");
                return;
            }
            
            const response = await JService.get(
                `/api/v1/integrations/kyc/result?session_id=${sessionIdRef.current}`,
            );
            
            if (response?.status === "PENDING") {
                await getResult();
            };
            if (response.result === "PASSED") {
                onPassed?.(response);
                return;
            } else if (response.result === "FAILED" || response.result === "REJECTED") {
                onFailed?.("KYC process failed. Please retry or contact support@frejun.com");
                return;
            } else if (response.result === "INCONCLUSIVE") {
                onRetry("Unable to process. Image quality, data, or document may be unclear. Please try again.")
            } else if (response.result === "UNRECOGNIZED") {
                onRetry("The document type could not be identified. Please retry.")
            } else if (response.result === "INCOMPLETE") {
                onRetry("Verification failed due to a technical issue, missing data, or timeout. Please retry.")
            }
            
        } catch (err) {
            onFailed?.(err?.message || "KYC process failed. Please contact support@frejun.com");
        }
    }

    useEffect(() => {
        const messageHandler = async (event) => {
            console.log("Received message kyc:", event.data);
            const page = event.data?.page;
            // Listen for the message indicating the user has completed the KYC process
            if (page === "/success") {
                if (!sessionIdRef.current) return;
                retryCountRef.current = 0;
                await getResult();
            }
        };

        window.addEventListener("message", messageHandler);
        return () => {
            window.removeEventListener("message", messageHandler);
        };
    }, []);
    
    if (!securemeLink) return null;
    return (
        <iframe
        style={{
            width: "100%",
            height: "100%",
            border: 0,
                display: "block",
                ...style,
            }}
            title="kyc"
            src={securemeLink}
            allow="camera; microphone; autoplay; fullscreen"
            allowFullScreen
        />
    );
}

export default Index